<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>活码信息</span>
      </div>
      <el-form
        ref="activitiesForm"
        :model="activitiesInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="180px"
      >
        <div class="add-form-item">
          <el-form-item label="活码名称：" prop="activitiesName">
            <el-input v-model="activitiesInfo.activitiesName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入30个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="描述：" prop="des">
            <el-input type="textarea" v-model="activitiesInfo.des"></el-input>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="活码：" prop="activitiesIoid">
            <el-input
              v-model="activitiesInfo.activitiesIoid"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="二维码图片：">
            <img :src="activitiesInfo.codeContent" />
          </el-form-item>
        </div>
        <el-form-item>
          <div @click="upload()" style="color: #409EFF">
            下载图片
          </div>
        </el-form-item>
        <div class="add-form-item">
          <el-form-item label="输入下载图片的大小：" prop="ioidSize">
            <el-input v-model="activitiesInfo.ioidSize"></el-input>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="着陆页：" prop="activitiesUrl">
            <el-input v-model="activitiesInfo.activitiesUrl"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入80个字符</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="submit">修改</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      activitiesInfo: {
        activitiesId: "",
        activitiesName: "",
        activitiesIoid: "",
        activitiesUrl: "",
        des: "",
        codeContent: "",
        ioidSize: ""
      },
      rules: {
        activitiesName: [
          {
            max: 30,
            message: "最多输入30个字符",
            trigger: "change"
          }
        ],
        activitiesUrl: [
          {
            max: 80,
            message: "最多输入80个字符",
            trigger: "change"
          }
        ],
        ioidSize: [
          {
            validator: this.validateCom,
            message: "输入下载图片的大小不能超过1000！",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    //下载图片大小校验
    validateCom(rule, value, callback) {
      const one = Number(value);
      if (one > 1000) {
        return callback(new Error("输入值最大不超过1000"));
      }
      return callback();
    },
    //下载
    upload() {},
    getActivitiesById: function(id) {
      let _this = this;
      let param = {
        url: "/api/activities/getActivitiesById",
        params: {
          activitiesId: id
        }
      };

      _this.$store.dispatch("getActivitiesById", param).then(() => {
        _this.activitiesInfo =
          _this.$store.state.activities.activitiesData.activitiesInfo;
        _this.activitiesInfo.codeContent =
          "http://qrcode.leipi.org/js.html?qw=150&qc=" +
          _this.activitiesInfo.codeContent;
      });
    },
    submit() {
      let _this = this;
      _this.$refs.activitiesForm.validate(isPass => {
        if (isPass) {
          let param = {
            url: "/api/activities/updateActivitiesInfo",
            params: {
              activitiesId: _this.activitiesInfo.activitiesId,
              activitiesName: _this.activitiesInfo.activitiesName,
              activitiesUrl: _this.activitiesInfo.activitiesUrl,
              des: _this.activitiesInfo.des
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "活码信息维护成功",
                  type: "success"
                });
                this.$router.push({
                  name: "activitiesIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善活码信息!",
            type: "warning"
          });
        }
      });
    }
  },
  created() {
    let _this = this;
    let id = this.$route.params.activitiesId;
    if (id !== null && id !== "" && id !== undefined) {
      _this.getActivitiesById(id);
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
